import React from 'react';

import { QuizContext } from './QuizProvider';

export function useQuizState() {
  const context = React.useContext(QuizContext);

  if (!context) {
    throw new Error('use only context provider!');
  }

  return context;
}
